import moment from "moment";
const today = moment();
export const disableFutureDate = (current) => {
  return current.isBefore(today);
};